import { inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Router, type CanActivateFn } from "@angular/router";
import { CognitoService } from "../services/cognito.service";

export const authGuard: CanActivateFn = async () => {
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const cognitoService = inject(CognitoService);
  const router = inject(Router);

  try {
    const isAuthenticated = await cognitoService.isAuthenticated();

    if (!isAuthenticated) {
      return router.createUrlTree(["/login"]);
    }

    return true;
  } catch (error) {
    console.error("Auth guard error:", error);
    return router.createUrlTree(["/login"]);
  }
};
